import { Component, OnInit, ViewContainerRef, viewChild } from '@angular/core';
import { showHide } from '../../modal-animations';
import { Modal } from '../../modal';

@Component({
    selector: 'app-modal-template-no-close',
    templateUrl: './modal-template-no-close.component.html',
    styleUrls: ['./modal-template-no-close.component.scss'],
    animations: [showHide],
    standalone: false
})
export class ModalTemplateNoCloseComponent extends Modal implements OnInit {

  readonly contentRef = viewChild('content', { read: ViewContainerRef });

  constructor() {
    super();
  }

  ngOnInit() {

  }

}
